
import {Vue, Component} from 'vue-property-decorator';
import Template from "@/views/system-management/template/index.vue";
import {InventoryRecord} from "@/views-oms/closing-position/components/specifyInventory.vue";
import {getCustomsPacking, removeRelatedInventoryPacking, searchRelatedInventoryPacking} from "@/api/closing-order";

@Component({
  components: {Template}
})
export default class RelatedInventory extends Vue {
  private dialogVisible = false;
  private records: InventoryRecord[] = [];
  private piInfoId = '';
  private clId = '';

  public openDialog(clId, piInfoId, data: any) {
    this.dialogVisible = true;
    this.clId = clId;
    this.piInfoId = piInfoId;
    this.records = data;
  }

  private closeDialog() {
    this.dialogVisible = false;
    this.modelKeyword = ''
  }

  private removeSubmit() {
    this.closeDialog();
    this.$emit("removeSubmit");
  }

  private removeLoading = false;
  private removePopoverVisible = false;

  private async removeInventory() {
    this.removeLoading = true;
    let result = this.records
        .flatMap((e) => e.packings)
        .filter(e => e.isSelected)
        .map(e => e.id);
    if (result.length === 0) {
      this.$message.warning('请选择要移除的行')
      this.removeLoading = false;
      this.removePopoverVisible = false;
      return;
    }
    try {
      await removeRelatedInventoryPacking(this.clId, {piInfoId: this.piInfoId, customsPackingIds: result});
      this.removeSubmit();
    } catch (e) {
      this.$message.error(e.message);
    } finally {
      this.removeLoading = false;
      this.removePopoverVisible = false;
    }
  }

  private modelKeyword = '';
  private searchLoading = false;

  private async search() {
    this.searchLoading = true;
    try {
      let data: any = await searchRelatedInventoryPacking(this.clId, {
        piInfoId: this.piInfoId,
        model: this.modelKeyword
      });
      this.records = data;
    } catch (e) {
      this.$message.error(e.message);
    } finally {
      this.searchLoading = false;
    }
  }

  // table 内容
  private isInnerSelection = false; // 新增标志位,为了防止handleSelectionChange检测到了变化，而做处理。
  /**
   * 内部变化 -> 引起外部变化
   * 内部table 行选中状态更新，同时改变外层table的选中状态
   * @param selection
   * @param row
   * @private
   */
  private handlerInnerTbChange(selection, row: InventoryRecord) {
    let outerTbRef: any = this.$refs.outerTbRef;
    this.isInnerSelection = true;
    if (selection.length === 0) {
      outerTbRef.toggleRowSelection(row, false);
    } else {
      outerTbRef.toggleRowSelection(row, true);
    }
    this.isInnerSelection = false;
    row.packings.forEach((packing) => {
      let isSelected = selection.some(i2 => i2.id === packing.id);
      this.$set(packing, 'isSelected', isSelected);
    })
  }

  /**
   * 外部变化 -> 引起内部变化（updateInnerTbByOuterTb）
   * 外部table的勾选行变化，同时更新内部table的行的选中状态。
   * 如果是内部table更新外部table行选中状态，则不进行同步更新内部table行选中状态。
   * @param selection 选中行
   * @private
   */
  private handleSelectionChange(selection) {
    if (this.isInnerSelection) {
      return;
    }
    let outerTbRef: any = this.$refs.outerTbRef;
    this.records.forEach((row) => {
      const isSelected = selection.some(selectedRow => selectedRow.groupKey === row.groupKey);
      outerTbRef.toggleRowSelection(row, isSelected); // 更新外层表格
      // 更新内部表格的选中状态
      row.packings.forEach((value) => {
        this.$set(value, 'isSelected', isSelected);
        this.updateInnerTbByOuterTb(value, isSelected, 'innerTbRef_' + row.groupKey);
      });
    });
  }

  /**
   * 内部变化
   * 根据外层table勾选情况，更新内部table的选中状态
   * @param row 外层table当前行数据
   * @param selected 外层table当前行是否被选中
   * @param refName 内部table的ref名称
   * @private
   */
  private updateInnerTbByOuterTb(row, selected, refName) {
    let tbRef: any = this.$refs[refName];
    if (tbRef) {
      tbRef.toggleRowSelection(row, selected);
    }
  }
}
